import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
  );
}

export default function Auth({ mode }) {
  const isSignup = mode === "signup";
  const { user, login, loading } = useAuth();

  if (!loading && user) return <Navigate to="/profile" replace />;

  return (
    <main className="min-h-[70vh] flex items-center justify-center px-5 py-16" data-testid={`${mode}-page`}>
      <div className="w-full max-w-md">
        <div className="text-left mb-8">
          <p className="font-mono-label text-[11px] text-[#3F4CE0]">RiskPedia USA</p>
          <h1 className="mt-2 font-display font-bold text-[34px] tracking-tight">{isSignup ? "Find your framework. Today." : "Welcome back."}</h1>
          <p className="mt-2 text-[14.5px] text-[#1A1914]/55">{isSignup ? "Sign up with Google. No credit card." : "Log in to your saved assessments and Sam's chat history."}</p>
        </div>
        <div className="bg-white border border-[#E7E0D2] rounded-2xl p-7 shadow-sm">
          <button onClick={login} data-testid="google-auth-btn" className="w-full flex items-center justify-center gap-3 px-5 py-3.5 text-[15px] font-semibold border border-[#E7E0D2] rounded-xl hover:border-[#1A1914]/40 hover:bg-[#FAF7F1] rp-btn">
            <GoogleIcon /> Continue with Google
          </button>
          <ul className="mt-6 space-y-2.5">
            {["AI Framework Finder — 4 matched frameworks for your industry", "212+ glossary terms with detailed breakdowns", "Sam's chat history saved across sessions"].map((b) => (
              <li key={b} className="flex gap-2 text-[13px] text-[#1A1914]/65"><span className="text-[#12B76A] mt-0.5">✦</span>{b}</li>
            ))}
          </ul>
          <p className="mt-6 text-center text-[13px] text-[#1A1914]/55">
            {isSignup ? "Already have an account? " : "New to RiskPedia USA? "}
            <Link to={isSignup ? "/login" : "/signup"} className="font-semibold text-[#3F4CE0] hover:underline">{isSignup ? "Log in" : "Create free account"}</Link>
          </p>
        </div>
        <p className="mt-5 text-center text-[11.5px] text-[#1A1914]/40">Secured by Emergent Google sign-in · sessions last 7 days.</p>
      </div>
    </main>
  );
}
